import { render, staticRenderFns } from "./BudgetExpense.vue?vue&type=template&id=5aeed7d1&"
import script from "./BudgetExpense.vue?vue&type=script&lang=js&"
export * from "./BudgetExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports